"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDatepickerState = exports.trackButtonClick = exports.setStartDateFocus = exports.setEndDateFocus = exports.reducer = exports.initialTrackerParamsState = exports.initialState = exports.initialDatesState = exports.changeShiftAction = exports.changeDates = exports.changeCurrentCells = void 0;

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialStateCell = {
  date: null
};
var initialDatesState = {
  left: initialStateCell,
  right: initialStateCell,
  shift: 0,
  inputFocuses: {
    isStartDateFocus: false,
    isEndDateFocus: false
  }
};
exports.initialDatesState = initialDatesState;
var initialTrackerParamsState = {
  buttonsClicked: [],
  initialTab: null
};
exports.initialTrackerParamsState = initialTrackerParamsState;

var initialState = _objectSpread(_objectSpread({}, initialDatesState), initialTrackerParamsState);

exports.initialState = initialState;
var ActionType = {
  DATES: 'changeDates',
  CELLS: 'changeCells',
  CURRENT_CELLS: 'changeCurrentCells',
  SHIFT: 'changeShift',
  SET_START_FOCUS: 'cigarette/setStartFocus',
  SET_END_FOCUS: 'cigarette/setEndFocus',
  UPDATE: 'updateDatePickerState',
  TRACK_BUTTON_CLICK: 'cigarette/clickedButtons'
};

var reducer = function reducer(state, action) {
  switch (action.type) {
    case ActionType.DATES:
      {
        var _action$payload = action.payload,
            startDate = _action$payload.startDate,
            endDate = _action$payload.endDate;

        var left = _objectSpread(_objectSpread({}, state.left), {}, {
          date: startDate
        });

        var right = _objectSpread(_objectSpread({}, state.right), {}, {
          date: endDate
        });

        return _objectSpread(_objectSpread({}, state), {}, {
          left: left,
          right: right
        });
      }

    case ActionType.SHIFT:
      {
        var shift = action.payload;
        return _objectSpread(_objectSpread({}, state), {}, {
          shift: shift
        });
      }

    case ActionType.SET_START_FOCUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          inputFocuses: {
            isStartDateFocus: true,
            isEndDateFocus: false
          }
        });
      }

    case ActionType.SET_END_FOCUS:
      {
        return _objectSpread(_objectSpread({}, state), {}, {
          inputFocuses: {
            isStartDateFocus: false,
            isEndDateFocus: true
          }
        });
      }

    case ActionType.UPDATE:
      {
        return _objectSpread(_objectSpread({}, state), action.payload);
      }

    case ActionType.TRACK_BUTTON_CLICK:
      {
        var buttonName = action.payload;
        var clickedButtons = state.buttonsClicked || [];
        var isClickedBefore = clickedButtons.indexOf(buttonName) !== -1;
        if (isClickedBefore) return _objectSpread({}, state);
        return _objectSpread(_objectSpread({}, state), {}, {
          buttonsClicked: [].concat(_toConsumableArray(clickedButtons), [buttonName])
        });
      }

    default:
      throw new Error('Incorrect action');
  }
};

exports.reducer = reducer;

var changeShiftAction = function changeShiftAction(shift) {
  return {
    type: ActionType.SHIFT,
    payload: shift
  };
};

exports.changeShiftAction = changeShiftAction;

var changeDates = function changeDates(payload) {
  return {
    type: ActionType.DATES,
    payload: payload
  };
};

exports.changeDates = changeDates;

var changeCurrentCells = function changeCurrentCells(payload) {
  return {
    type: ActionType.CURRENT_CELLS,
    payload: payload
  };
};

exports.changeCurrentCells = changeCurrentCells;

var setStartDateFocus = function setStartDateFocus() {
  return {
    type: ActionType.SET_START_FOCUS
  };
};

exports.setStartDateFocus = setStartDateFocus;

var setEndDateFocus = function setEndDateFocus() {
  return {
    type: ActionType.SET_END_FOCUS
  };
};

exports.setEndDateFocus = setEndDateFocus;

var updateDatepickerState = function updateDatepickerState(payload) {
  return {
    type: ActionType.UPDATE,
    payload: payload
  };
};

exports.updateDatepickerState = updateDatepickerState;

var trackButtonClick = function trackButtonClick(payload) {
  return {
    type: ActionType.TRACK_BUTTON_CLICK,
    payload: payload
  };
};

exports.trackButtonClick = trackButtonClick;